<template>
  <div>
    <Navbar/>
    <div id="detail">

      <img alt="Vue logo" src="../../assets/images/visit.png">
      <br>
      <div class="HelloWorld">
        <iframe src="https://m.gifanimados.com/Gifs-Mensajes/Animaciones-Gracias/Gracias-49371.gif" width="480" height="270" frameBorder="0" class="giphy-embed" allowFullScreen></iframe>

      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
export default {
  name: 'Logout',
  components:{
    Navbar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#detail{
  text-align: center;
  margin-top: 5%;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
